import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { SessionService } from "../session/session.service";
import { ActivatedRoute } from "@angular/router";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public session: SessionService, private route: ActivatedRoute) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      this.route.snapshot.firstChild &&
      this.route.snapshot.firstChild.url.length > 0 &&
      this.route.snapshot.firstChild.url[0].path === "questionnaires"
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.session.getItem(
            "questionnaire-token"
          )}`,
        },
      });
      return next.handle(request);
      //.catch((err, caught) => {
      //   if (err.error.internalStatus === 607) {
      //     localStorage.removeItem('questionnaire-token');
      //     sessionStorage.removeItem('questionnaire-token');
      //     window.location.reload();
      //     return Observable.never();
      //   }
      //   return Observable.throw(err);
      // });
    } else {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.session.getToken()}`,
        },
      });
      return next.handle(request).catch((err, caught) => {
        if (err.error.internalStatus === 607) {
          localStorage.removeItem("token");
          sessionStorage.removeItem("token");
          window.location.reload();
          return Observable.never();
        }
        return Observable.throw(err);
      });
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/auth/token.interceptor.ts